import { z } from 'zod';

import { schemaId } from '../utils/schema.utils';

export const schemaBasicMailTemplate = z.object({
    aggregateId: schemaId.optional(),
    createdAt: z.string().optional(),
    data: z.object({
        mailContent: z.string().min(1),
        mailHTMLContent: z.string().min(1),
        subject: z.string(),
    }),
    id: schemaId.optional(),
    name: z.string().nullable(),
    priority: z.union([z.number(), z.string()]).nullable(),
});

export type SchemaBasicMailTemplate = z.infer<typeof schemaBasicMailTemplate>;
